import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectDto, ProjectToAdd, WPO2CreateProjectRequest } from 'shared';
import { ProjectService } from 'shared';
import { AddProjectDialogComponent } from './add-project-dialog/add-project-dialog.component';
import { NotificationService } from 'shared';
import { TranslateService } from 'shared';
import { OAuthServiceService } from 'shared';
import { GridApi, GridOptions, IDatasource, IGetRowsParams, SortModelItem } from 'ag-grid-community';
import { GenericFilter } from 'shared';
import { AdminProjectsButtonRendererComponent } from './admin-projects-button-renderer/admin-projects-button-renderer.component';
import { AgGridProjectsSettings } from './AgGridProjectsSettings';
import { TenantService } from 'shared';
import { PermissionsService } from 'shared';
import { TenantDto } from 'shared';
import { DatabaseMigrationService } from 'shared';

@Component({
    selector: 'manage-projects',
    templateUrl: './manage-projects.component.html',
    styleUrls: ['./manage-projects.component.scss'],
    standalone: false
})
export class ManageProjectsComponent implements OnInit {
  rowData: ProjectDto[] = [];
  initRowData: ProjectDto[] = [];
  allProjects: ProjectDto[] = [];
  unfilteredProjects: ProjectDto[] = [];
  _db!:string;
  _tenantName!:string;

  globalParams!: IGetRowsParams;
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  components: any;
  filter!: GenericFilter;
  aggridSettings!: AgGridProjectsSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  onlyArchived = false;
  isUpdating = false;
  isWPTenant = false;
  isForceReadDb = true; // weil Refresh nicht funktioniert

  _addProjectRole!: string;
  _projectRole!: string;
  _manageProjectsRole!: string;
  wpTenant!: string;
  wpServerUrl!: string;

  //_aberting!: string;
  // _tenantDb!:string;

  _userRoles:string[] = [];

  minDateTime = new Date("0001-01-01T00:00:00");

  private _userDataRolesReady = false;
  private _tokenRolesReady = false;
  private _rolesWorkRebuilt = false;

  constructor(
    private oauthService: OAuthServiceService,
    private projectService: ProjectService,
    private databaseMigrationService: DatabaseMigrationService,
    private tenantService:TenantService,
    //private permissionService: PermissionsService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private notificationService: NotificationService
    ) { }

  ngOnInit(): void {
    var self = this;

    // this._tenantName = localStorage.getItem('current-tenant-name') as string;
    // this._tenantDb = localStorage.getItem('current-tenant-db') as string;
    this._tenantName = this.tenantService.currentTenantName;
    console.log("------> manage-projects - tenant DB",this.tenantService.currentTenantDb);
    console.log("------> manage-projects - tenant ID",this.tenantService.currentTenantId);

          this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
            next: (tenant:TenantDto) => {
              this.isWPTenant = tenant.systemType === 'WINPLAN';
              this.wpServerUrl = tenant.wpServerUrl;
              this.wpTenant = tenant.wpTenant;
          }
        }) 

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          //self._userRoles = (data as any).role as Array<string>;
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((role: string) =>{
            if (role != "MANAGE_USERS" && role != "CREATE_USER" &&  role != "MANAGE_PROJECTS" && role != "CREATE_PROJECT") self._userRoles.push(role);
          })
          //console.log("------> manage-projects self.userRoles (userData): ", self._userRoles)
        }
        // userData kommt asynchron - _userRoles ist zum Zeitpunkt des synchronen work()-Aufrufs
        // unten noch leer. Sobald auch die Token-Rollen da sind, aggridSettings mit den
        // tatsaechlichen Rollen neu aufbauen (Guard verhindert Mehrfachaufbau).
        this._userDataRolesReady = true;
        this.rebuildWorkWhenRolesReady();
      }
    });
    this.tenantService.getToken(this._tenantName).subscribe({
      next: (token) => {
        var tenantRoles = this.tenantService.getTenantRoles(token);
        console.log("------> manage-projects tenantRoles (token): ", tenantRoles)
        tenantRoles.forEach((role: string)=> {
          if (role != "" && !this._userRoles.includes(role)) self._userRoles.push(role);
        });
        console.log("------> manage-projects self.userRoles (token): ", self._userRoles)
        this._tokenRolesReady = true;
        this.rebuildWorkWhenRolesReady();
      }
    });

    this.work();
  }

  private rebuildWorkWhenRolesReady() {
    if (this._rolesWorkRebuilt || !this._userDataRolesReady || !this._tokenRolesReady) return;
    this._rolesWorkRebuilt = true;
    this.work();
  }

  work() {
    console.log("===========> entering work")
    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridProjectsSettings(this.translate, this.tenantService,
                              this._userRoles.includes('MANAGE_PROJECTS') || this._userRoles.includes('TENANTADMIN') || this._userRoles.includes('admin'),
                              this._userRoles.includes('CREATE_PROJECT') || this._userRoles.includes('TENANTADMIN') || this._userRoles.includes('admin'));
    this.components = { buttonRenderer: AdminProjectsButtonRendererComponent}
    this.gridOptions = this.aggridSettings.agGridProjectsSettings;

  }

  onRowClicked(rowData: any) {
    console.log('Row wurde geklickt:', rowData);
  }

onGridReady(params: any) {
  this.gridApi = params.api;

  this.gridApi.sizeColumnsToFit();
  const datasource = {
    rowCount: 0,
    getRows: (dsParams: IGetRowsParams) => {

      if (this.gridApi) {
        this.gridApi.showLoadingOverlay();
      }
      this.isLoadingResults = true;

      this.globalParams = dsParams;
      this.filter.className = 'TenantProject';
      this.filter.startRow = dsParams.startRow;
      this.filter.endRow = dsParams.endRow;
      this.filter.sortItems = dsParams.sortModel;
      this.filter.clientFilters = dsParams.filterModel;

      const sort = dsParams.sortModel[0]?.sort ?? "asc";
      const filterText = dsParams.filterModel.display_Name?.filter ?? "";

      if (this.rowData.length === 0 || this.isForceReadDb) {

        this.tenantService.getTenantProjects(this._tenantName, this.filter).subscribe({
          next: (projects) => {

            this.allProjects = projects;

            const filtered = this.onlyArchived
              ? projects.filter(x => new Date(x.archivedWhen).getTime() > this.minDateTime.getTime() && x.archivedWhen != null)
              : projects.filter(x => new Date(x.archivedWhen).getTime() === this.minDateTime.getTime() || x.archivedWhen == null);

            const sorted = filtered.sort((a, b) => {
              return sort === "asc"
                ? a.display_Name.localeCompare(b.display_Name)
                : b.display_Name.localeCompare(a.display_Name);
            });

            const rows = sorted.slice(dsParams.startRow, dsParams.endRow);
            const lastRow = sorted.length <= dsParams.endRow ? sorted.length : -1;

            if (this.gridApi) {
              dsParams.successCallback(rows, lastRow);
              this.gridApi.hideOverlay();
            }

            this.rowData = rows;
            this.resultsLength = rows.length;
            this.isLoadingResults = false;
          },

          error: (error) => {
            this.isLoadingResults = false;

            if (this.gridApi) {
              this.gridApi.hideOverlay();
            }

            this.notificationService.error(
              `${this.translate.data["ERROR"]}`,
              `${this.translate.data["PROJECTRETRIEVALERROR"]}`
            );

            this.notificationService.info("", error.error.developerMessage.Message);
          }
        });

      } else {

        let projects = this.allProjects;

        const filtered = this.onlyArchived
          ? projects.filter(x => new Date(x.archivedWhen).getTime() > this.minDateTime.getTime() && x.archivedWhen != null)
          : projects.filter(x => new Date(x.archivedWhen).getTime() === this.minDateTime.getTime() || x.archivedWhen == null);

        const sorted = filtered.sort((a, b) => {
          return sort === "asc"
            ? a.display_Name.localeCompare(b.display_Name)
            : b.display_Name.localeCompare(a.display_Name);
        });

        const finalFiltered = filterText
          ? sorted.filter(x => x.display_Name.toLowerCase().includes(filterText.toLowerCase()))
          : sorted;

        const rows = finalFiltered.slice(dsParams.startRow, dsParams.endRow);
        const lastRow = finalFiltered.length <= dsParams.endRow ? finalFiltered.length : -1;

        if (this.gridApi) {
          dsParams.successCallback(rows, lastRow);
          this.gridApi.hideOverlay();
        }

        this.rowData = rows;
        this.resultsLength = rows.length;
        this.isLoadingResults = false;
      }
    }
  };

  this.gridApi.updateGridOptions({datasource: datasource});
}


  migrateWPO2Projects() {
    var request = new WPO2CreateProjectRequest();
    request.WPO2_TENANT = this.wpTenant;
    request.WPO2_SERVERURL = this.wpServerUrl;
    this.tenantService.migrateWPO2Projects(this._tenantName, request).subscribe({
      next: (response) => {
        console.log("-------> manage-projects: migrateWPO2Projects() - projects = ", response);
        if (response.length > 0) {
          response.forEach((project: ProjectDto) => {
            console.log("-------> manage-projects: migrateWPO2Projects() - project = ", project);
            this.allProjects.push(project);
          });
          this.gridApi.refreshInfiniteCache();
          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, "WPO2 Projekte erfolgreich migriert!");
        } else {
          this.notificationService.info(`${this.translate.data["INFO"]}`, "Keine WPO2 Projekte zur Migration vorhanden!");
        }
      },
      error: (error: any) => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error migrating WPO2 projects");
        console.error("Error migrating WPO2 projects:", error);
        //console.error("Error migrating WPO2 projects:", error.error.developerMessage.Message);
        // if (error.error.developerMessage && error.error.developerMessage.Message) 
        // {
        //   this.notificationService.info("", error.error.developerMessage.Message);
        // } else {
          this.notificationService.info("", error.error);
        // }
      }
    });
  }

  addProject() {
    console.log("-------> manage-project: addProject()")
    // const dialogRef = this.dialog.open(AddProjectDialogComponent, { width: '800px', data: ProjectToAdd , position: { top: '300px', left: '350px' }});
    const dialogRef = this.dialog.open(AddProjectDialogComponent, { height: '600px', width: '800px', data: ProjectToAdd});
    dialogRef.afterClosed().subscribe({
      next: (project: ProjectDto) => {
        if (project !== undefined) {
          this.allProjects.push(project);
          this.gridApi.refreshInfiniteCache();
        }
      },
      error: (error: any) => this.notificationService.error("Error while closing dialog", error)
    });
  }

  onChange(){
    this.onlyArchived=!this.onlyArchived;
    // console.log("onlyArchivedProjects = ", this.onlyArchived)
    // console.log("rowData1 = ", this.rowData)
    this.rowData = this.allProjects;
    // this.rowData = this.rowData.slice(this.filter.startRow, this.filter.endRow);   
    this.gridApi.refreshInfiniteCache();
  }

  async updateAllProjects(){
    this.isUpdating = true;
    let i;
    for (i = 0; i < this.rowData.length; i++) {
      const cellElement = document.querySelectorAll(
        `.ag-row[row-index="${i}"] .ag-cell:nth-child(2) button`
      )[3]; // vierter Button
      if (cellElement) {
        (cellElement as HTMLButtonElement).click(); // Klick auf den Button auslösen
        await this.Sleep(500);
      }

    }  
    this.isUpdating = false;
  }

  Sleep(milliseconds: number) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
    }
}


